import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    FormStore,
    inject,
    Input,
    Loader,
    Modal,
    ModalHandle,
    TasksStore,
    uuidv4generate,
} from 'Mri.Web.Common';
import * as React from 'react';
import { BsFileEarmark } from '@react-icons/all-files/bs/BsFileEarmark';
import { Button, Form, FormGroup } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { PartsStore } from './PartsStore';

export interface ICreatePartParams {
    partDefinitionGuid: string;
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class CreatePart extends React.Component<ICreatePartParams> {
    @computed
    private get footer() {
        return (
            <Button color="primary" onClick={this.submitAsync} disabled={this.loading}>
                <Loader loading={this.loading} showSpinner message="Creating Part..." />
                {!this.loading && 'Create Part'}
            </Button>
        );
    }
    public render() {
        return (
            <Modal title={this.title} modalHandle={this.props.modalHandle} footer={this.footer} bodyClass="p-0">
                {this.partForm && !!this.partForm!.globalErrors.length && (
                    <div className="alert-danger p-2">
                        <ul>
                            {this.partForm!.globalErrors.map((e, idx) => (
                                <li key={idx}>{e}</li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="p-3">
                    <Form>
                        <FormGroup color={this.partForm!.fields.serialNumber.state}>
                            <label>Serial Number</label>

                            <Input type="text" id="name" field={this.partForm!.fields.serialNumber} required />
                        </FormGroup>
                    </Form>
                </div>
            </Modal>
        );
    }

    @bind
    @action
    private async submitAsync() {
        if (!this.partForm) throw new Error('Form does not exist');

        this.partForm.onSubmit();
        if (this.partForm.validate()) {
            this.loading = true;
            const task = this.tasksStore.startSessionTask(`Create Part`);

            try {
                await this.partsStore.createAsync(this.partForm.values);
                task.complete();
                this.props.modalHandle.close();
            } catch (e: any) {
                if (e.modelState) {
                    this.partForm.clearGlobalErrors();
                    this.partForm.addErrors(e.modelState);
                }

                task.error(e);
            } finally {
                this.loading = false;
            }
        } else {
            console.log('invalid');
            this.loading = false;
        }
    }

    private title = (
        <span className="text-header fw-bold">
            <BsFileEarmark /> Create Part
        </span>
    );

    @observable private loading = false;

    @inject private readonly partsStore!: PartsStore;
    @inject private tasksStore!: TasksStore;
    @inject private readonly accountStore!: AccountStore;

    @observable private partForm? = new FormStore<Mri.Parts.Part>({
        partNumber: null,
        revision: null,
        serialNumber: '',
        isAssembly: false,
        description: '',
        modelDescription: '',
        modelNumber: '',
        partGuid: uuidv4generate(),
        children: null,
        parentPartGuid: null,
        partStatus: {
            userId: this.accountStore.user!.id,
            startDate: new Date(),
            partState: 1,
            comments: null,
        },
        partDefinitionGuid: this.props.partDefinitionGuid,
    });
}
